var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-date-picker',{attrs:{"show-adjacent-months":"","full-width":"","show-current":true},on:{"click:date":_vm.selectedDate},model:{value:(_vm.picker),callback:function ($$v) {_vm.picker=$$v},expression:"picker"}}),_c('div',{staticClass:"d-flex flex-column"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }